module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gr-c51a52c416ea428fe41f7cee240d7640.svg";